import React from "react";
import { Row, Col, Card } from "antd";
import { formatNumber } from "../../../../store/utils/format_number/format_number";

const CashupTotal = ({ total, color }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const totalValue = formatNumber(total);
  // -------------------------- MAIN --------------------------
  const title = <div style={{ fontSize: 18, color: color }}>Total:</div>;
  const value = (
    <div style={{ fontSize: 18, color: color }}> ${totalValue} </div>
  );

  return (
    <Row span={24} style={{ width: "100%" }}>
      <Col span={24}>
        <Card className="total-card">
          <Row style={{ width: "100%", margin: "6px 0px" }}>
            <Col span={14}>{title}</Col>
            <Col span={10} align="right">{value}</Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default CashupTotal;
